
import React, { useState } from 'react';
import { AppLanguage } from '../utils/i18n';

interface LanguagePickerProps {
  show: boolean;
  onSelect: (lang: AppLanguage) => void;
}

const LanguagePicker: React.FC<LanguagePickerProps> = ({ show, onSelect }) => {
  const [fading, setFading] = useState(false);

  if (!show) return null;

  const handleSelect = (lang: AppLanguage) => {
    setFading(true);
    setTimeout(() => onSelect(lang), 400);
  };

  return (
    <div className={`fixed inset-0 z-[600] flex items-center justify-center p-6 transition-opacity duration-400 ${fading ? 'opacity-0' : 'opacity-100'}`}>
      <div className="absolute inset-0 bg-[#020617]/95 backdrop-blur-xl" />
      <div className="relative w-full max-w-sm space-y-8 text-center">
        <div className="flex justify-center">
          <div className="w-20 h-20 bg-indigo-600/20 border border-indigo-500/30 rounded-3xl flex items-center justify-center text-4xl">
            🌐
          </div>
        </div>

        <div className="space-y-2">
          <p className="text-xs font-black uppercase tracking-[0.4em] text-indigo-400">Language / Idioma / Taal</p>
          <h1 className="text-4xl font-black italic uppercase tracking-tight text-white leading-tight">
            Choose Your<br />Language
          </h1>
          <p className="text-slate-400 text-sm">Elige tu idioma · Kies je taal</p>
          <p className="text-slate-600 text-[10px] font-bold uppercase tracking-widest">You can change this later in settings</p>
        </div>

        <div className="space-y-4">
          <button
            onClick={() => handleSelect('en')}
            className="w-full flex items-center justify-center gap-4 py-5 px-6 bg-indigo-600 hover:bg-indigo-500 text-white font-black uppercase tracking-widest rounded-2xl text-sm transition-all active:scale-95 shadow-xl"
          >
            <span className="text-2xl">🇬🇧</span>
            English
          </button>
          <button
            onClick={() => handleSelect('es')}
            className="w-full flex items-center justify-center gap-4 py-5 px-6 bg-slate-800 hover:bg-slate-700 text-white font-black uppercase tracking-widest rounded-2xl text-sm transition-all active:scale-95 border border-slate-700"
          >
            <span className="text-2xl">🇪🇸</span>
            Español
          </button>
          <button
            onClick={() => handleSelect('nl')}
            className="w-full flex items-center justify-center gap-4 py-5 px-6 bg-slate-800 hover:bg-slate-700 text-white font-black uppercase tracking-widest rounded-2xl text-sm transition-all active:scale-95 border border-slate-700"
          >
            <span className="text-2xl">🇧🇪</span>
            Nederlands
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguagePicker;
